import { apiSlice } from "./ApiSlice";


const AddPurchaseApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    AddPurchase: builder.mutation({
      query: (data) => {
        return {
          url: "/Purchase-AddPurchases-InsertOrUpdate",
          method: "POST",
          body: data,
        };
      },
    }),

GetDistributorList: builder.query({
  query: ({ pharmaId, distributorName }) => ({
    url: `/Purchase-GetSearchDistributorList?pharmaId=${pharmaId}&distributorName=${distributorName}`,
    method: "GET",
  }),
}),

 GetProductList: builder.query({
  query: ({ pharmaId, productname }) => {
    console.log("pharmaId:", pharmaId, "productname:", productname);
    return {
      url: `/Stock-GetPharmaProductList?pharmaId=${pharmaId}&productname=${productname}`,
      method: "GET",
    };
  },
}),


GetSearchBatchList: builder.query({
  query: ({ pharmaId, ProductID, batchnum }) => ({
    url: `/Stock-GetSearchBatchList?PharmaID=${pharmaId}&ProductID=${ProductID}${batchnum ? `&batchnum=${batchnum}` : ""}`,
    method: "GET",
  }),
}),



  }),
});

export const { useAddPurchaseMutation, useLazyGetProductListQuery, useLazyGetSearchBatchListQuery, useLazyGetDistributorListQuery } = AddPurchaseApiSlice;
    